import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { forwardRef, useEffect, useState } from 'react';
import { useDebounceEffect } from '@/common/hooks/useDebounceEffect';
import { routeProvider } from '@/common/utils';
import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Box,
  Collapse,
  IconButton,
  Link,
  useTheme
} from '@mui/material';

interface DaysLeftAlertProps {
  message: string;
  isDesktop: boolean;
  onLoad: (isLoad: boolean) => void;
  onClose: () => void;
  open: boolean;
}

type Ref = HTMLDivElement;

export const DaysLeftAlert = forwardRef<Ref, DaysLeftAlertProps>(
  ({ message, isDesktop, onLoad, open, onClose }, ref) => {
    const { push, query } = useRouter();
    const theme = useTheme();
    const { t } = useTranslation();
    const [isSubscribeNowVisible, setIsSubscribeNowVisible] =
      useState<boolean>(true);

    const goToPayments = () =>
      push({
        pathname: routeProvider.userAcount,
        query: { tab: 'payments' }
      });

    useDebounceEffect(() => onLoad(true), 100, []);
    useEffect(() => {
      query.hasOwnProperty('tab') && query['tab'] === 'payments'
        ? setIsSubscribeNowVisible(false)
        : setIsSubscribeNowVisible(true);
    }, [query]);

    return (
      <Box
        sx={{
          position: 'fixed',
          top: isDesktop ? 0 : theme.header.height,
          left: isDesktop ? theme.sidebar.width : 0,
          width: isDesktop ? 'calc(100vw - 300px)' : '100%',
          zIndex: 1
        }}
      >
        <Collapse in={open}>
          <Alert
            severity="error"
            ref={ref}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={onClose}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{
              color: theme.palette.mode === 'dark' && '#ff8888',
              backgroundColor: theme.palette.mode === 'dark' && '#190206',
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0
            }}
          >
            {message}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {isSubscribeNowVisible && (
              <Link
                onClick={goToPayments}
                sx={{ fontWeight: 'bold', cursor: 'pointer' }}
              >
                {t('Subscribe now')}
              </Link>
            )}
          </Alert>
        </Collapse>
      </Box>
    );
  }
);
